import { StorageConfig } from '@ngx-pwa/local-storage';
import { ApplicationConfig } from '@config/application.config';

export default {
  IDBDBName: `${ ApplicationConfig.applicationName }_storage`,
  LSPrefix: `${ ApplicationConfig.applicationName }_storage_`
} as StorageConfig;
